export default () => {
  import('assets/styles/global.css');
};
